import { jsxs, jsx } from "react/jsx-runtime";
import { Popper, Popover, Heading } from "@zillow/constellation";
import { event } from "@zillow/universal-analytics";
import React__default from "react";
function FieldTooltip({
  title,
  body,
  interactionEventCmsInfo
}) {
  return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
    " ",
    /* @__PURE__ */ jsx(Popper, { triggered: /* @__PURE__ */ jsx(Popover, { header: /* @__PURE__ */ jsx(Heading, { level: 6, children: title }), body }), onOpen: () => {
      if (interactionEventCmsInfo) {
        event({
          envelope: {
            event_type_id: "5030",
            event_type_version_id: "1",
            event_template_id: "297",
            event_template_version_id: "1"
          },
          clickstream_trigger: {
            trigger_type_nm: "interaction",
            trigger_location_nm: "cms",
            trigger_source_nm: "cms_tooltip",
            trigger_object_nm: "no_trigger_object"
          },
          semantic: {
            semantic_event_nm: "cms_open"
          },
          cms_info: interactionEventCmsInfo
        });
      }
    }, onClose: () => {
      if (interactionEventCmsInfo) {
        event({
          envelope: {
            event_type_id: "2051",
            event_type_version_id: "1",
            event_template_id: "126",
            event_template_version_id: "1"
          },
          clickstream_trigger: {
            trigger_type_nm: "interaction",
            trigger_location_nm: "cms",
            trigger_source_nm: "cms_tooltip",
            trigger_object_nm: "no_trigger_object"
          },
          semantic: {
            semantic_event_nm: "cms_close"
          },
          cms_info: interactionEventCmsInfo
        });
      }
    } })
  ] });
}
export {
  FieldTooltip as default
};
